<que-question *ngIf="focusId$() ==index" class="question-form" [index]="index!" [formControl]="question"
    (deleteMeEvent)="deleteMeEvent.emit(index)"
    (dupliacteQuestionEvent)="dupliacteQuestionEvent.emit(index)"></que-question>
<que-question-display *ngIf="focusId$() !=index" class="question-form"
    [question]="questionSignal$()!"></que-question-display>
